export const ArrowDownIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none">
    <g id="vuesax/outline/arrow-down">
      <g id="arrow-down">
        <path
          id="Vector"
          d="M7.00038 9.80036C6.59204 9.80036 6.18371 9.64286 5.87454 9.3337L2.07121 5.53036C1.90204 5.3612 1.90204 5.0812 2.07121 4.91203C2.24038 4.74286 2.52038 4.74286 2.68954 4.91203L6.49288 8.71536C6.77288 8.99536 7.22788 8.99536 7.50788 8.71536L11.3112 4.91203C11.4804 4.74286 11.7604 4.74286 11.9295 4.91203C12.0987 5.0812 12.0987 5.3612 11.9295 5.53036L8.12621 9.3337C7.81705 9.64286 7.40871 9.80036 7.00038 9.80036Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
